// esbuild browser shims
// This file is injected into all bundles to provide Node.js compatibility
// See: https://esbuild.github.io/api/#inject

// Shim process for libraries that access it dynamically at runtime.
// Note: static references like process.env.NODE_ENV are replaced inline
// by esbuild's 'define' option - this shim catches dynamic access.
export const process = {
  env: {
    NODE_ENV: 'development'
  }
}
